import { CrmFieldData, CrmFieldValue, ExternalCrmField } from "../../../AppDataProvider/types";
import { Input, InputElement } from "../../../common/components";
import { CrmFieldType } from "../../../GeneratedGraphQL";
import React from "react";
export type CrmFieldsProps = {
  crmFieldData: CrmFieldData;
  crmFields: ExternalCrmField[];
  errors: Record<string, string>;
  onCrmFieldValueChange: (crmFieldId: string, newValue: CrmFieldValue) => void;
};
export function CrmFields({
  crmFields,
  crmFieldData,
  errors,
  onCrmFieldValueChange
}: CrmFieldsProps): React.ReactElement {
  return <>
      {crmFields.map(field => {
      const {
        id,
        name,
        required,
        type
      } = field;
      const variant = type === CrmFieldType.Date ? "date" : "text";
      const props = {
        error: errors[id],
        label: name,
        onChange: (event: React.ChangeEvent<InputElement>) => {
          if (variant === "date" && event.target.value && Number(event.target.value.split("-")[0]) > 9999) {
            event.target.value = "9999-" + event.target.value.split("-").slice(1).join("-");
          }
          onCrmFieldValueChange(id, event.target.value);
        },
        required,
        value: crmFieldData[id] ?? ""
      };
      return <Input key={id} id={id} variant={variant} {...props} />;
    })}
    </>;
}
export default CrmFields;